import * as exports from '@pipes/index';

export const Pipes = [
  exports.CTimePipe,
  exports.CDatePipe,
];
